import React, { useState, useEffect, useRef } from "react";
import { clearToken } from "../api";

interface UserDropdownProps {
  userName: string;
  userEmail: string;
  onSettingsClick: () => void;
}

export function UserDropdown({ userName, userEmail, onSettingsClick }: UserDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  function handleLogout() {
    clearToken();
    window.location.href = "/login";
  }

  function handleSettings() {
    setIsOpen(false);
    onSettingsClick();
  }

  return (
    <div className="admin-user-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="admin-user-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="admin-user-avatar">{userName.charAt(0).toUpperCase()}</div>
        <div className="admin-user-info">
          <span className="admin-user-name">{userName}</span>
          <span className="admin-user-email">{userEmail}</span>
        </div>
        <span className={`material-symbols-outlined admin-user-chevron ${isOpen ? "open" : ""}`}>
          expand_less
        </span>
      </button>
      {isOpen && (
        <div className="admin-user-menu">
          <button type="button" className="admin-user-menu-item" onClick={handleSettings}>
            <span className="material-symbols-outlined">settings</span>
            <span>Settings</span>
          </button>
          <button type="button" className="admin-user-menu-item" onClick={handleLogout}>
            <span className="material-symbols-outlined">logout</span>
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
}
